// extracted by mini-css-extract-plugin
module.exports = {"container":"HeadingStepss-module__container","mobileSep":"HeadingStepss-module__mobileSep"};